import { useActivities } from '../hooks/useActivities.js';
import RandomRunMap from '../components/RandomRunMap.jsx';
import Footer from '../components/Footer.jsx';
import Loading from '../components/Loading.jsx';

/** Standalone full-screen random-run showcase (page-random-run.php). */
export default function RandomRunPage() {
  const { data, loading } = useActivities();

  if (loading) return <Loading />;

  return (
    <>
      <RandomRunMap data={data} />
      <Footer />
    </>
  );
}
